import { render, staticRenderFns } from "./UpdatedStatusWarning.vue?vue&type=template&id=dbd699ac&scoped=true"
import script from "./UpdatedStatusWarning.vue?vue&type=script&lang=ts"
export * from "./UpdatedStatusWarning.vue?vue&type=script&lang=ts"
import style0 from "./UpdatedStatusWarning.vue?vue&type=style&index=0&id=dbd699ac&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbd699ac",
  null
  
)

export default component.exports